import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.Modal = class Modal extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-modal';
    }

    constructor(element) {
        super(element);

        this.modalIsOpen = false;
        this.modalOpenClass = 'fa-modal--modal-open';
    }

    render() {
        this.setVars();
        this.initModalService();

        $(function() {
            for(let child in document.body.children) {
                if( !document.body.children.hasOwnProperty(child)) continue;

                if (document.body.children[child].nodeName === 'svg') {
                    document.body.children[child].setAttribute('focusable', 'false');
                }
            }
        });
    }

    setVars() {
        this.focusableElements = [];
        this.$modalContents = this.$element.find('.js-modal-contents');
        this.$modalCloseButton = this.$element.find('.js-modal-close');
        this.$modalTitle = this.$element.find('.js-modal-title');
        this.$modalVideoDuration = this.$element.find('.js-modal-video-duration');
        this.$modalBase = this.$element.find('.js-modal-base');
        this.fullscreenClass = 'fullscreen';
    }

    initModalService() {
        this.$window.on('modal:openModal', this.onOpenModalEvent.bind(this));
        this.$window.on('keyup', this.onKeyupEvent.bind(this));
        this.$modalCloseButton.on('click', this.onCloseModalButtonClick.bind(this));
        this.$modalBase.on('click', this.onModalBaseClick.bind(this));
    }

    onOpenModalEvent(event, options) {
        this.modalIsOpen = true;
        this.$previousFocusedElement = options.$prevElement;
        this.openModal(options);
    }

    onKeyupEvent(event) {
        if (event && event.keyCode === 27 && this.modalIsOpen) {
            this.closeModal();
        }
    }

    onCloseModalButtonClick() {
        this.closeModal();
    }

    openModal(options) {
        const $template = options && options.$view;
        const title = options && options.title;
        const isFullscreen = options && options.fullscreen;
        const videoDuration = options && options.videoDuration;
        this.isUnclosable = options && options.unclosable;
        this.unclosableBase = options && options.unclosableBase;

        this.$body.addClass(this.modalOpenClass);
        this.$body.trigger('body:block');
        this.toggleFocusable(false);
        if ($template) {
            this.$modalContents.append($template.html());
            this.$modalTitle.text(title);
            this.$element.attr('tabindex', '0').focus();
            this.$window.trigger('modal:modalHasOpened', [this]);

            if (isFullscreen) {
                this.$element.addClass(this.fullscreenClass);
            }
            if (this.$modalVideoDuration.length && videoDuration) {
                this.$modalVideoDuration.text(videoDuration);
            }
        }

        $(window).trigger('content:updated');
    }

    closeModal() {
        if (this.isUnclosable) {
            this.redirect();
            return;
        }
        this.toggleFocusable(true);
        this.modalIsOpen = false;
        this.$body.removeClass(this.modalOpenClass);
        this.$body.trigger('body:unblock');
        this.$modalContents.empty();
        this.$modalVideoDuration.empty();
        this.$previousFocusedElement.focus();
        this.$element.removeClass(this.fullscreenClass);
    }

    onModalBaseClick() {
        this.closeModal();
    }

    toggleFocusable(shouldFocus) {
        const focusableSelectors = ['a[href]',
            'area[href]',
            'input:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            'button:not([disabled])',
            'iframe',
            'object',
            'embed',
            '[contenteditable]'].join(',');

        if ( !shouldFocus ) {
            this.focusableElements = $('body')
            .children(':not([data-fa-modal])')
            .find(focusableSelectors)
            .toArray();
        }

        this.focusableElements.forEach((element) => {
            element.setAttribute('tabindex', shouldFocus ? '0' : '-1');
        });
    }

    redirect() {
        this.$modalCloseButton.attr('disabled', '');
        let redirectUrl;
        const matches = document.referrer.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
        const domain = matches && matches[1];
        if (domain && domain.indexOf('thefa.com') > -1) {
            redirectUrl = document.referrer;
        } else {
            redirectUrl = `${window.location.protocol}//${window.location.hostname}${this.unclosableBase}`;
        }

        window.location.href = redirectUrl;
    }
};

Snappy.Component.ModalTrigger = class ModalTrigger extends Snappy.BaseComponent {
    static get tagName() {
        return 'fa-modal-trigger';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.addEventListeners();
    }

    addEventListeners() {
        this.$element.on('click', this.onModalTriggerClick.bind(this));
    }

    onModalTriggerClick(event) {
        const $view = this.$body.find(this.$element.data('modal-template'));
        const modalTitle = this.$element.data('modal-title');
        const $prevElement = event && $(event.currentTarget);
        this.$window.trigger('modal:openModal', {
            $view: $view,
            title: modalTitle,
            $prevElement: $prevElement
        });
    }
};



// WEBPACK FOOTER //
// ./components/modal/scripts/modal.js